export default __webpack_public_path__ + "static/media/loading.9a3c631e.gif";